/* Why a discount code entered in the cart was refused, so the cart can say
   something more useful than "invalid code".

   Some promo codes (e.g. SNOW26-50, a Pixoo app discount gated on the
   FW26-promo-qualified customer tag) can only be recognised once Shopify knows
   who the shopper is. In the online-store cart that is only true when the
   shopper is logged in; a guest is identified at checkout by the email they
   enter. Most qualifying shoppers have no store account at all, so "log in"
   is not an answer: they must apply the code at checkout with the email that
   received it.

   Pure logic, no DOM: loaded as a classic script before the cart-drawer.js
   module (exposes window.dpdDiscountErrorReason) and required directly by
   tests/discount-error-reason.test.js. */
(function () {
  'use strict';

  function parsePrefixes(raw) {
    return String(raw || '')
      .split(',')
      .map(function (p) { return p.trim().toUpperCase(); })
      .filter(Boolean);
  }

  function isGated(code, prefixes) {
    var c = String(code || '').trim().toUpperCase();
    if (!c) return false;
    return parsePrefixes(prefixes).some(function (p) { return c.indexOf(p) === 0; });
  }

  /* Returns one of:
     'network'      the request failed; nothing is known about the code.
     'checkout'     customer-linked code, guest shopper: apply it at checkout
                    with the email that received it.
     'not_eligible' customer-linked code, logged-in shopper: this account or
                    cart doesn't meet the offer's conditions.
     'invalid'      anything else (unknown, expired, not applicable). */
  function discountErrorReason(opts) {
    var o = opts || {};
    if (o.networkError) return 'network';
    if (isGated(o.code, o.gatedPrefixes)) return o.loggedIn ? 'not_eligible' : 'checkout';
    return 'invalid';
  }

  if (typeof window !== 'undefined') {
    window.dpdDiscountErrorReason = discountErrorReason;
  }
  if (typeof window === 'undefined' && typeof module !== 'undefined') {
    module.exports = { discountErrorReason: discountErrorReason, isGated: isGated, parsePrefixes: parsePrefixes };
  }
})();
